// extracted by mini-css-extract-plugin
module.exports = {"loader-aligment":"styles_loader-aligment__m2_qr","custom-layout":"styles_custom-layout__3xz8I"};